import { Button, Flex, Modal, Stack, Text, Tooltip } from "@mantine/core";
import { handleMergeIdeasFromIdids, unLinkToProductItem, updateDuplicateIdea } from "../../../Api";
import { showNotification } from "@mantine/notifications";
import { useAuth0 } from "@auth0/auth0-react";
import { useContext, useState } from "react";
import AssignedIdeaInfo from "../right-bar/evidence-card/actions/MatchActions/AssignedIdeaInfo";
import { DuplicationType, DuplicationTypeLabels } from "../../../types/constants";
import { useNavigate } from "react-router-dom";
import IdeaContext from "../IdeaContext";
import { resolveLinkedProductItemId } from "../../../utils/ideaDeliveryLink";

const DuplicateIdeaModal = ({
  idea,
  duplicateIdea,
  duplicationId,
  duplicationType,
  verifyOpened,
  setVerifyOpened,
}: {
  idea: any;
  duplicateIdea: any;
  duplicationId?: string;
  duplicationType?: DuplicationType;
  verifyOpened: boolean;
  setVerifyOpened: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const navigate = useNavigate();
  const auth0 = useAuth0();
  const { loadIdea } = useContext(IdeaContext);
  const [mergeLoading, setMergeLoading] = useState(false);
 
  const handleDuplicateIdea = () => {
    updateDuplicateIdea(duplicationId ||duplicateIdea?.duplicationId, auth0).then((res) => {
      if (res.status === 200) {
        showNotification({
          title: 'Success',
          message: 'Idea marked as not-a-duplication successfully',
        });
      }
      setVerifyOpened(false);
    })
  }

  const handleMergeIdeas = async () => {
    const ids = [
      idea?._id,
      duplicateIdea?._id,
      duplicateIdea?.duplicationId,
    ].filter(Boolean) as string[];
    if (!idea?._id || ids.length < 2) return;
    setMergeLoading(true);
    try {
      const productItemId = resolveLinkedProductItemId(idea);
      if (productItemId) {
        await unLinkToProductItem(idea._id, productItemId, auth0);
        await loadIdea?.();
      }
      const res: any = await handleMergeIdeasFromIdids(ids, auth0);
      if (res.status === 200) {
        showNotification({
          title: "Success",
          message: "Ideas merged successfully",
        });
        const data = res?.data;
        const mergedIdeaId =
          data?.idea?._id ??
          data?.idea?.id ??
          data?._id ??
          data?.mergedIdeaId ??
          duplicateIdea?._id;
        setVerifyOpened(false);
        if (mergedIdeaId) {
          navigate(`/idea/${mergedIdeaId}`, {
            state: { openReviewDescription: true },
          });
        }
      } else {
        setVerifyOpened(false);
      }
    } catch (e: any) {
      console.error(e);
      showNotification({
        title: "Error",
        message: "Could not complete merge. Try again.",
        color: "red",
      });
    } finally {
      setMergeLoading(false);
    }
  };

  return (
    <Modal
      yOffset={150}
      opened={verifyOpened}
      onClose={() => setVerifyOpened(false)}
      h="45vw"
      size="32vw"
    >
      <Stack mx="sm" mb={0}>
        <Stack mb={5} mt={-5}>
          <Text fz={14} mr={5} lineClamp={1}>
          There is a similar Idea that might be a duplication
          </Text>
          <Text fz={14}>
            <b>Reason:</b> "{DuplicationTypeLabels[duplicationType || duplicateIdea?.duplicationType as DuplicationType]}"
          </Text>
          <AssignedIdeaInfo assignedIdea={duplicateIdea} />
        </Stack>
        

        <Flex justify="space-around" style={{ width: "100%" }} mt={13} mb={13}>
          

          <Button
            mx="md"
            styles={(theme) => ({
              root: {
                height: "32px",
                backgroundColor: "#5C5CEB",
                fontWeight: 400,
                "&:hover": {
                  backgroundColor: theme.fn.darken("#5C5CEB", 0.05),
                },
              },
              leftIcon: {
                marginRight: 15,
              },
            })}
            onClick={() => handleDuplicateIdea()} 
          >
            Mark as not-a-duplication
          </Button>
          <Tooltip 
            w={250} 
            maw={250}
            multiline 
            label={'You will be able to select which title and description to keep later'}>

            <Button
              mx="md"
              loading={mergeLoading}
              styles={(theme) => ({
                root: {
                  height: "32px",
                  backgroundColor: "#5C5CEB",
                  fontWeight: 400,
                  "&:hover": {
                    backgroundColor: theme.fn.darken("#5C5CEB", 0.05),
                  },
                },
                leftIcon: {
                  marginRight: 15,
                },
              })}
              onClick={handleMergeIdeas}
            >
            Merge ideas
            </Button>
            
          </Tooltip>
          
        </Flex>
      </Stack>
    </Modal>
  );
};

export default DuplicateIdeaModal;
